import { createSliceWithThunks } from '@castlery/shared-redux-core';
import { createAsyncThunk, type PayloadAction } from '@reduxjs/toolkit';
import { WarrantyOffer } from '../entity/warranty.entity';

interface WarrantyState {
  selectedOfferId: string;
  warrantyList: WarrantyOffer[];
  warrantyIsFetching: boolean;
}

const initialStateWarranty: WarrantyState = {
  selectedOfferId: '',
  warrantyList: [],
  warrantyIsFetching: true,
};

export const warrantySlice = createSliceWithThunks({
  name: 'Warranty',
  initialState: initialStateWarranty,
  reducers: (create) => {
    return {
      setSelectedOfferId: create.reducer((state, { payload }: PayloadAction<string>) => {
        state.selectedOfferId = payload;
      }),
      resetSelectedOfferId: create.reducer((state) => {
        state.selectedOfferId = '';
      }),
      setWarrantyList: create.reducer((state, { payload }: PayloadAction<WarrantyOffer[]>) => {
        state.warrantyIsFetching = false;
        state.warrantyList = payload;
      }),
      setWarrantyIsFetching: create.reducer((state, { payload }: PayloadAction<boolean>) => {
        state.warrantyIsFetching = payload;
      }),
    };
  },
  selectors: {
    selectedOfferId: (state) => state.selectedOfferId,
    selectWarrantyList: (state) => state.warrantyList,
    selectCurrentWarrantyOffer: (state) =>
      state.warrantyList?.find((x) => x.warranty_offer_id === state.selectedOfferId),
    selectWarrantyIsFetching: (state) => state.warrantyIsFetching,
  },
});

export const warrantyReducer = warrantySlice.reducer;
export const { setSelectedOfferId, resetSelectedOfferId, setWarrantyList, setWarrantyIsFetching } =
  warrantySlice.actions;
export const { selectedOfferId, selectWarrantyList, selectWarrantyIsFetching, selectCurrentWarrantyOffer } =
  warrantySlice.selectors;

export const warrantySDKLoadSuccess = createAsyncThunk('warranty/warrantySDKLoadSuccess', async () => {
  return null;
});
